import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ResultsPage from "./pages/ResultsPage";
import CampaignsPage from "./pages/CampaignsPage";
import { Toaster } from "./components/ui/sonner";
import { GateModalProvider } from "./hooks/useGateModal";

function App() {
  return (
    <div className="App">
      <GateModalProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/results/:resultId" element={<ResultsPage />} />
            <Route path="/campaigns" element={<CampaignsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </GateModalProvider>
      <Toaster position="top-right" />
      <div className="noise-overlay" />
    </div>
  );
}

export default App;
